import { gql } from "graphql-request";

const SERVER_DELETE_USER_FIELD = gql`
  mutation SERVER_DeleteUserField($id: ID!) {
  deleteUserField(id: $id)
}
`;
export default SERVER_DELETE_USER_FIELD;
